export const normalizePaymentUiMode = (uiMode) => {
    if (typeof uiMode !== 'string') {
        return null;
    }

    const normalizedUiMode = uiMode.trim().toLowerCase();

    return normalizedUiMode || null;
};

export const getCurrentPaymentUiMode = () => {
    const query = new URLSearchParams(window.location.search);

    return normalizePaymentUiMode(query.get('ui_mode'));
};

export const isHostedPaymentUiMode = (uiMode) => normalizePaymentUiMode(uiMode) === 'hosted';

export const shouldUseEmbeddedCheckout = (uiMode) => !isHostedPaymentUiMode(uiMode);
